module.exports = __webpack_public_path__ + "assets/202509252035/fonts/iconfont.851d413f.woff";